import { render, staticRenderFns } from "./QueryPolicyGroup.vue?vue&type=template&id=f2725c96&"
import script from "./QueryPolicyGroup.vue?vue&type=script&lang=js&"
export * from "./QueryPolicyGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports